import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import Label from './Label'
import HelpText from './HelpText'

const FormRenderer = observer((props) => {
  const { store } = props
  const fields = props.fields.map((field, i) => {
    return {...field, key: i}
  })
  return (
    <Fragment>
      {
        fields.map((fieldData) => {
          const FormComponent = fieldData.component
          const { id } = fieldData

          const label = fieldData.label ? (
            <Label htmlFor={id}>{fieldData.label}</Label>
          ) : (
            null
          )
      
          const helpText = fieldData.helpText ? (
            <HelpText>{fieldData.helpText}</HelpText>
          ) : (
            null
          )
          return (
            <div key={fieldData.key} className='field'>
              {label}
              <div className='control'>
                <FormComponent key={id} fieldData={fieldData} store={store} />
              </div>
              {helpText}
            </div>
          )
        })
      }
    </Fragment>
  )
})

export default FormRenderer



// WEBPACK FOOTER //
// ./src/components/generic/FormRenderer.js